import React, { useMemo } from 'react';
import clsx from 'clsx';

import { Styled } from './index.styles';
import { useConditionalPageContextSERP, useConditionalServerDataHotelOverviewSERP } from '../../../hooks';
import { overviewMockData } from '../mockdata/overview';
import { useCheckBreakpoint } from '../../../hooks';
import { useHQVContext } from '../../../context/HQVContext';
import { useSearchResultsStore } from '../../../modules/store/searchResultsStore';

const Overview: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { jsonContent }: any = useConditionalServerDataHotelOverviewSERP();
  const { hqvState } = useHQVContext();
  const { pageState, isAuthorMode, pageVal } = useConditionalPageContextSERP();
  const isViewportL = useCheckBreakpoint('viewportL');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const overviewData = useSearchResultsStore((state: { propertyInfoData: any }) => state.propertyInfoData);

  const propertyOverviewData = useMemo(() => {
    return pageState?.authorMode || isAuthorMode ? overviewMockData.textContentData : overviewData?.propertyInfoData;
  }, [pageState, overviewData]);

  let selectedDescription = '';
  propertyOverviewData?.property?.basicInformation?.descriptions.forEach(
    (description: { type: { code: string }; text: string; localizedText: { translatedText: string } }) => {
      if (description?.type?.code === 'location') {
        selectedDescription = description?.text;
      }
    }
  );

  return (
    <Styled>
      {selectedDescription && (
        <div
          className={clsx(
            pageVal === 'chat' ? '' : 'px-3',
            'color-scheme1',
            'hotel-overview-container',
            `${hqvState?.modalOpenState ? 'hqv-modal' : ''}`
          )}
        >
          <div
            className={clsx(
              'overview-title-container',
              pageVal === 'chat' ? 'overview-title-container__chat-container' : ''
            )}
          >
            {jsonContent && (
              <h2
                className={clsx(
                  pageVal === 'chat' ? 't-subtitle-m' : isViewportL ? 't-title-s' : 't-subtitle-xl',
                  'overview-title'
                )}
              >
                {jsonContent.overviewLabel}
              </h2>
            )}
            <p
              className={clsx(
                pageVal === 'chat' ? 't-font-s pb-5' : isViewportL ? 't-font-m' : 't-font-s',
                'overview-description'
              )}
            >
              {selectedDescription}
            </p>
          </div>
        </div>
      )}
    </Styled>
  );
};

export default Overview;
